export default "__VITE_ASSET__6atyArvL__"